import type { HelperState } from '../types';

const transitions: Record<HelperState, HelperState[]> = {
  IDLE: ['MOVING'],
  MOVING: ['PREPARING', 'CLEANING', 'HELPING', 'RETURNING'],
  PREPARING: ['RETURNING'],
  CLEANING: ['RETURNING'],
  HELPING: ['RETURNING'],
  RETURNING: ['IDLE'],
};

export class HelperStateMachine {
  private current: HelperState = 'IDLE';

  get state(): HelperState {
    return this.current;
  }

  transition(next: HelperState): void {
    if (!transitions[this.current].includes(next)) throw new Error(`Invalid helper transition: ${this.current} -> ${next}`);
    this.current = next;
  }
}
